module.exports = __webpack_public_path__ + "img/datos_sku.d3508ccc.svg";